import { Dispatch } from "react";
import { GETAPI, POSTAPI } from "../../API/Api";
import {
  SESSION_REQUEST,
  SIGNIN_FAIL,
  SIGNIN_REQUEST,
  SIGNIN_SUCCESS,
  SIGNOUT_FAIL,
  SIGNOUT_REQUEST,
  SIGNOUT_SUCCESS,
} from "../../Constants/AuthConstants";
import { ApiConfig } from "../../Config/CommonConfig";
import { deleteCookie, setCookie } from "../../utils/Helper";
import { DOMAIN_NAME } from "../../Config/Config";

const stripAuthTokens = (data: any) => {
  if (!data || typeof data !== "object") {
    return data;
  }
  const { access_token, refresh_token, ...rest } = data;
  return rest;
};

export const FetchLoginDetail =
  () => async (dispatch: Dispatch<any>, getState: () => any) => {
    const { login_status } = getState()?.UserLoginDataState || {};
    if (login_status !== true) {
      dispatch({ type: SESSION_REQUEST });
    }
    try {
      const data = await GETAPI(ApiConfig?.LoginDetail, false);
      if (data?.status === true) {
        dispatch({
          type: SIGNIN_SUCCESS,
          data: stripAuthTokens(data.data),
        });
      } else if (login_status !== true) {
        dispatch({
          type: SIGNIN_FAIL,
          data: null,
        });
      }
    } catch {
      if (getState()?.UserLoginDataState?.login_status !== true) {
        dispatch({
          type: SIGNIN_FAIL,
          data: null,
        });
      }
    }
  };

export const UserLogin = (payload: any) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch({ type: SIGNIN_REQUEST });
    let data = await POSTAPI(ApiConfig?.Login, payload);
    if (data?.status === true) {
      if (data?.data?.user_id) {
        setCookie("user_id", data?.data?.user_id);
      }
      dispatch({
        type: SIGNIN_SUCCESS,
        data: stripAuthTokens(data.data),
      });
      dispatch(FetchLoginDetail());
    } else {
      dispatch({
        type: SIGNIN_FAIL,
        data: [],
      });
    }
  } catch {
    dispatch({
      type: SIGNIN_FAIL,
      data: [],
    });
  }
};

export const UserLogoutAction =
  (payload: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: SIGNOUT_REQUEST });
      let data = await POSTAPI(ApiConfig?.Logout, payload, false);
      if (data?.status) {
        dispatch({
          type: SIGNOUT_SUCCESS,
          data: data,
        });
        localStorage.clear();
        deleteCookie("admintoken", "/", DOMAIN_NAME);
        deleteCookie("orgid", "/", DOMAIN_NAME);
        deleteCookie("user_id", "/", DOMAIN_NAME);
        window.location.href = "/login";
      } else {
        dispatch({
          type: SIGNOUT_FAIL,
          error: data?.message,
          data: [],
        });
      }
    } catch (error: any) {
      dispatch({
        type: SIGNOUT_FAIL,
        error: error?.message,
        data: [],
      });
    }
  };
